
import React from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

interface SitemapProps {
  path?: string;
}

/**
 * This component is used for static rendering of sitemaps.
 * It won't be visible to users but helps with SSR/SSG.
 */
export default function Sitemap({ path }: SitemapProps) {
  const location = useLocation();
  const sitemapPath = path || location.pathname;
  
  // In a real SSR environment, this would render the sitemap XML
  // But for client-side only, this just serves as a placeholder
  return (
    <div style={{ display: 'none' }} data-sitemap-path={sitemapPath}>
      {/* Sitemap content would be rendered server-side */}
    </div>
  );
}

// Helper for server-side rendering (not used in client-side React)
export async function generateSitemapForPath(path: string): Promise<string | null> {
  try {
    const response = await fetch(`https://vjthmlybhiphyoiipqjh.supabase.co/functions/v1/generate-sitemaps${path}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZqdGhtbHliaGlwaHlvaWlwcWpoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ4MDEzMTcsImV4cCI6MjA2MDM3NzMxN30.yk6mKYvwF7isMV-hGqTf5RWm4hp1NA9wW6NWywqQkFw`,
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache, no-store'
      }
    });

    if (!response.ok) {
      console.error(`Failed to generate sitemap for ${path}: ${response.statusText}`);
      return null;
    }

    return await response.text();
  } catch (error) {
    console.error('Error generating sitemap:', error);
    return null;
  }
}
